import { CreatorsWrapper } from '../creators/CreatorsWrapper.jsx';
import { hydrateRoot } from 'react-dom/client';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { ReactRelayContext } from 'react-relay/legacy.js';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { creatorsRoot } from '../creators/creatorsRoot.js';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import * as tracking from 'dibs-tracking';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const variables = serverVars.get('relayVariables');
const operation = createOperationDescriptor(getRequest(creatorsRoot), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ReactRelayContext
                value={{
                    environment,
                    variables: snapshot.variables || {},
                }}
            >
                <CreatorsWrapper
                    nationality={variables.nationality}
                    style={variables.style}
                    viewer={snapshot.data.viewer}
                    vertical={variables.vertical}
                />
            </ReactRelayContext>
        </IntlProvider>
    );
    tracking.trackPageview();
});
